const en = {
  common: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    discard: "Discard",
    loading: "Loading...",
    search: "Search",
    filter: "Filter",
    all: "All",
    actions: "Actions",
    yes: "Yes",
    no: "No",
    close: "Close",
    send: "Send",
    refresh: "Refresh",
    sign_out: "Sign Out",
    map: "Map",
    email: "Email",
    add: "Add",
    optional: "Optional",
    required: "Required",
    status: "Status",
    date: "Date",
    name: "Name",
    phone: "Phone",
    address: "Address",
    notes: "Notes",
    total: "Total",
    export: "Export",
  },
  nav: {
    overview: "Overview",
    inventory: "Inventory",
    layouts: "Layouts",
    orders: "Orders",
    appointments: "Appointments",
    availability: "Availability",
    customers: "Customers",
    leads: "Leads",
    permits: "Permits",
    ads: "Meta Ads",
    landing: "Landing Page",
    analytics: "Analytics",
    financials: "Financials",
    profit: "Profit Settlement",
    projects: "Projects",
    ai: "AI Insights",
    seo: "SEO",
    legal: "Legal",
    sales_list: "Sales List",
    settings: "Settings",
  },
  nav_groups: {
    main: "Main",
    operations: "Operations",
    sales: "Sales & CRM",
    marketing: "Marketing & SEO",
    finance: "Finance",
    system: "System",
  },
  header: {
    admin_dashboard: "Admin Dashboard",
    sales_dashboard: "Sales Dashboard",
    language: "Language",
  },
  pages: {
    overview: "Dashboard Overview",
    customers: "Customers",
    leads: "Leads",
    orders: "Orders",
    permits: "Building Permits — Lead Capture",
  },
  overview: {
    range: { "7d": "7 days", "30d": "30 days", "90d": "90 days", all: "All time" },
    kpis: {
      total_revenue: "Total Revenue",
      orders_suffix: "{{count}} orders",
      avg_project: "Avg Project Value",
      per_order: "Per order",
      deposit_install: "Deposit → Install",
      deposit_of: "{{a}} of {{b}}",
      expiration_rate: "Expiration Rate",
      expired: "{{count}} expired",
    },
    mini: {
      slabs: "Slabs",
      orders: "Orders",
      appointments: "Appointments",
      customers: "Customers",
    },
    charts: {
      revenue_trend: "Revenue Trend",
      revenue_trend_desc: "Monthly revenue and deposits over time",
      no_orders: "No order data yet — chart will populate as orders come in",
      revenue: "Revenue",
      deposits: "Deposits",
      material_dist: "Material Distribution",
      revenue_share: "Revenue share by material",
      catalog_no_revenue: "Materials in catalog (no revenue data yet)",
      conversion_funnel: "Conversion Funnel",
      funnel_desc: "Pipeline from quotes through reservations to completed orders",
      from_prev: "{{rate}}% from {{prev}}",
      stages: { quotes: "Quotes", reservations: "Reservations", orders: "Orders", completed: "Completed" },
      revenue_by_material: "Revenue by Material",
      revenue_by_material_desc: "Aggregated performance by material type",
      internal: "Internal",
      no_material_data: "No material data yet",
      total_revenue_label: "Total Revenue",
      avg_order_label: "Avg Order Value",
    },
    margin: {
      title: "Margin Estimation",
      confidential: "Confidential",
      desc: "Based on internal cost vs customer rate",
      empty: "Set internal_price_per_sqft in Settings to enable margin tracking",
      headers: { material: "Material", customer: "Customer $/sqft", internal: "Internal $/sqft", margin: "Est. Margin", revenue: "Revenue" },
    },
    reservations: {
      title: "Reservation Patterns",
      desc: "Hold durations and conversion metrics",
      active: "Active",
      converted: "Converted",
      expired: "Expired",
      avg_hold: "Avg Hold",
    },
    device: {
      title: "Conversion by Device",
      desc: "Requires server-side event forwarding from GTM. Device data is not yet stored in the database.",
    },
  },
  leads: {
    kpis: { total: "Total Leads", new: "New Leads", quoted: "Quoted" },
    search: "Search leads...",
    headers: { name: "Name", email: "Email", phone: "Phone", city: "City", project: "Project", status: "Status", date: "Date" },
    empty: "No leads yet",
    details: "Lead Details",
    company: "Company",
    timeline: "Timeline",
    preferred_contact: "Preferred Contact",
    notes: "Notes",
    quote: "Quote",
    linked: "Linked",
    status: {
      new_lead: "new lead",
      quoted: "quoted",
      contacted: "contacted",
      converted: "converted",
      appointment_scheduled: "appointment scheduled",
    },
  },
  customers: {
    kpis: { total: "Total Customers", new_week: "New This Week", showing: "Showing", matching: "matching results" },
    add: "Add Customer",
    search: "Search by name, email, or phone...",
    show_deleted: "Show deleted",
    no_name: "No name",
    loading: "Loading customers...",
    none_search: "No customers match your search.",
    none: "No customers registered yet.",
    active: "Active",
    deleted: "Deleted",
    headers: { name: "Name", email: "Email", phone: "Phone", status: "Status", registered: "Registered", actions: "Actions" },
    actions: { create_order: "Create Order", edit: "Edit", delete: "Delete", restore: "Restore" },
    add_dialog: { title: "Add Customer", desc: "Create a new customer record manually.", adding: "Adding..." },
    edit_dialog: { title: "Edit Customer", desc: "Update customer details.", save: "Save Changes" },
    delete_dialog: { title: "Delete customer?", desc: "This will soft-delete \"{{name}}\". They won't appear in the active list but can be restored later." },
    order_dialog: {
      title: "Create Order for {{name}}",
      desc: "Create a new order for this customer. You can edit all details on the order page.",
      customer: "Customer",
      amount: "Initial Amount ($)",
      amount_placeholder: "0.00 — can be set later",
      amount_help: "Optional. You can set the full amount on the order detail page.",
      create: "Create Order",
    },
    form: {
      full_name: "Full Name *",
      email: "Email *",
      password: "Password *",
      password_placeholder: "Set a default password",
      password_help: "Minimum 6 characters. Customer can change it after login.",
      phone: "Phone",
      address: "Address",
      notes: "Notes (internal)",
      send_welcome: "Send welcome email with login credentials",
    },
    toasts: {
      updated: "Customer updated",
      added: "Customer added",
      added_email: "Welcome email sent with credentials.",
      order_created: "Order created",
    },
  },
  orders: {
    new: "New Order",
    kpis: { total: "Total", pending: "Pending", in_progress: "In Progress", completed: "Completed" },
    quotes_pending: "Customer Quotes — Not Yet Converted to Orders",
    quote_headers: { id: "Quote ID", customer: "Customer", material: "Material", sqft: "Sq Ft", est_total: "Estimated Total", status: "Status", date: "Date", actions: "Actions" },
    guest: "Guest",
    create_order: "Create Order",
    search: "Search by customer or order ID...",
    filters: { all: "All Statuses", pending: "Pending", confirmed: "Confirmed", in_progress: "In Progress", completed: "Completed", cancelled: "Cancelled" },
    loading: "Loading orders...",
    none: "No orders found.",
    headers: { id: "Order ID", customer: "Customer", total: "Total", deposit: "Deposit", status: "Status", date: "Date", actions: "Actions" },
    send_estimate: "Send estimate to customer",
    delete_order: { title: "Are you sure you want to delete this order?", desc: "This action cannot be undone." },
    delete_quote: { title: "Are you sure you want to delete this quote?", desc: "This action cannot be undone." },
    toasts: {
      deleted: "Order deleted",
      delete_failed: "Failed to delete order",
      quote_deleted: "Quote deleted",
      created_from_quote: "Order created from quote",
      no_email: "No customer email",
      auto_confirmed: "{{count}} payment(s) auto-confirmed",
    },
  },
  permits: {
    subtitle: "Sarasota, Manatee & Charlotte.",
    tabs: { list: "Permit list", how: "How it works" },
    filters: {
      county: "County",
      tier: "Tier",
      status: "Status",
      all_counties: "All counties",
      all_tiers: "All tiers",
      all_statuses: "All statuses",
    },
    tier: { gold: "Gold", silver: "Silver", bronze: "Bronze", cold: "Cold" },
    status: {
      new: "New",
      contacted: "Contacted",
      converted: "Converted",
      discarded: "Discarded",
    },
    no_address: "(no address)",
    empty: "No permits yet. Run a scraper above or add one manually.",
    fields: {
      type: "Type",
      date: "Date",
      permit_value: "Permit",
      property_value: "Property",
      contractor: "Contractor",
      owner: "Owner",
      score_breakdown: "Score breakdown",
      ai_copy: "AI-generated copy",
      postal: "Postal",
      email_label: "Email",
      facebook_ad: "Facebook ad",
    },
    actions: {
      gen_copy: "Gen copy",
      mark_contacted: "Mark contacted",
      mark_converted: "✓ Converted",
      discard: "Discard",
      manual: "Manual",
      add_manual: "Add Permit Manually",
      run_scraper: "Run scraper",
      add_score: "Add & score",
    },
    email_dialog: {
      title: "Send email to {{address}}",
      recipient: "Recipient",
      subject: "Subject",
      body: "Body",
      send: "Send",
    },
    manual_form: {
      permit_number: "Permit number *",
      county: "County",
      project_type: "Project type",
      issued_date: "Issued date",
      address: "Address",
      city: "City",
      zip: "ZIP",
      permit_value: "Permit value $",
      property_value: "Property value $",
      contractor: "Contractor",
      owner_name: "Owner name",
      owner_email: "Owner email (optional)",
      description: "Description",
      cat: {
        kitchen_remodel: "Kitchen remodel",
        bath_remodel: "Bath remodel",
        new_construction: "New construction",
        addition: "Addition",
        other: "Other",
      },
    },
    toasts: {
      scraper: "{{county}}: {{inserted}} new, {{updated}} updated",
      scraper_failed: "Scraper failed",
      copy_generated: "Copy generated",
      copy_failed: "Copy generation failed",
      updated: "Updated",
      email_sent: "Email sent",
      email_queued: "Saved to queue",
      permit_added: "Permit added, scored & copy generated",
      permit_number_required: "Permit number required",
    },
    how: {
      title: "How the system works",
      scrape: "<b>Scrape:</b> the buttons above run Firecrawl on the county portal and pull recent permits.",
      score: "<b>Automatic score (0–100):</b> deterministic rules score the lead based on project type, permit value, property value and date.",
      tier: "<b>Tier:</b> 75+ Gold · 50–74 Silver · 25–49 Bronze · <25 Cold.",
      copy: "<b>AI copy:</b> for Gold/Silver leads, generates ready-to-use postal, email and Facebook ad copy.",
      send: "<b>Send:</b> the Email button sends via Resend (if connected) or queues for manual sending.",
      manual: "<b>Manual:</b> any permit discovered through other channels can be added with the \"+\" button above.",
      note: "For automatic sending, connect Resend in Workspace → Connectors.",
    },
  },
  sales_list: {
    title: "Sales List",
    subtitle: "Pick who to share. Reps see name, phone, address, project and the work order.",
    link_card: "Sales rep link",
    copy: "Copy",
    shared_card: "In shared list ({{count}})",
    shared_empty: "No customers shared yet.",
    select_card: "Select customers",
    search: "Search name, phone, city...",
    add: "Add ({{count}})",
    open: "Open",
    remove: "Remove from list",
    select_aria: "Select {{name}}",
    already: "already in list",
    headers: { name: "Name", phone: "Phone", address: "Address", project: "Project", order: "Order", source: "Source", info: "More info" },
    info: { placeholder: "Add notes for the sales rep...", saved: "Info saved", save_error: "Failed to save info" },
    source: { lead: "Lead", appointment: "Appointment", order: "Order", customer: "Customer", manual: "Manual" },
    csv_file: "sales-list.csv",
    reps: {
      card: "Sales reps",
      desc: "Each sales rep gets their own Google Spreadsheet with only their assigned customers.",
      name_placeholder: "Sales rep name",
      add: "Create link",
      copy: "Copy link",
      remove: "Delete rep",
      empty: "No sales reps yet.",
      unassigned: "Unassigned",
      header: "Sales rep",
      created: "Sales rep link created",
      create_error: "Failed to create sales rep",
      removed: "Sales rep deleted",
      assign_error: "Failed to assign sales rep",
      name_required: "Enter the sales rep name",
    },
    sheet: {
      card: "Google Spreadsheet",
      desc: "Sync the shared list to a Google Spreadsheet your sales reps can open.",
      sync: "Sync now",
      syncing: "Syncing...",
      open: "Open spreadsheet",
      not_created: "The spreadsheet is created automatically on the first sync.",
      synced: "Spreadsheet updated ({{count}} rows)",
      sync_error: "Failed to sync the spreadsheet",
    },
    attachments: {
      header: "Attachments",
      add: "Attach PDF",
      uploading: "Uploading...",
      remove: "Remove attachment",
      none: "—",
      only_pdf: "Please upload PDF files only.",
      too_large: "File too large (max 15 MB).",
      uploaded: "Attachment added",
      upload_error: "Failed to attach file",
      removed: "Attachment removed",
      remove_error: "Failed to remove attachment",
    },

    toasts: {
      load_error: "Failed to load",
      nothing_to_add: "Nothing to add",
      nothing_to_add_desc: "Select customers that are not on the list yet.",
      add_error: "Failed to add",
      added: "{{count}} customer(s) added to the list",
      remove_error: "Failed to remove",
      link_copied: "Link copied",
      link_copied_desc: "Send it to your sales reps.",
    },
    public: {
      title: "Customers — Sales Team",
      subtitle: "List shared by Altar Stones. Internal use only.",
      count: "{{count}} customer(s)",
      loading: "Loading...",
      unavailable: "Unavailable",
      empty: "No customers shared at the moment.",
      no_order: "No order",
      work_order: "Work order",
      invalid_token: "Invalid link — token missing.",
      expired: "Invalid or expired link.",
      load_error: "Error loading the list ({{status}}).",
      generic_error: "Could not load the list.",
      pdf_error: "Failed to generate PDF",
      pdf: {
        title: "Work Order",
        customer: "Customer",
        specs: "Specifications",
        values: "Values",
        name: "Name",
        phone: "Phone",
        address: "Address",
        project: "Project",
        material: "Material",
        color: "Color",
        finish: "Finish",
        edge: "Edge profile",
        sqft: "Measurements (sqft)",
        scope: "Scope of Work",
        subtotal: "Subtotal",
        tax: "Tax",
        total: "Total",
        deposit: "Deposit paid",
        status: "Order status",
      },
    },
  },
};

export default en;
